var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-bill-container"},[_c('img',{attrs:{"src":require("@/assets/img/no-bill@2x.png")}}),_c('div',{staticClass:"tip"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }